import React, { Component } from 'react';
import './App.css';
import Autosuggest from 'react-autosuggest';
import _ from 'lodash';
import withRequisitionStep from './components/withRequisitionStep';
import withWorkflow from './components/withWorkflow';
import { scrollToMessage } from './util/scrollToMessage';
import MedicalNecessityDisclaimer from './components/MedicalNecessityDisclaimer';
import AccessionedOrderAlert from './components/AccessionedOrderAlert';

/**
 * Component for the 'dxCodes' step of the GEAR order workflow.
 */
class DiagnosisCodes extends Component {
	constructor(props) {
		super(props);
		var defaultValue = this.props.activeGearRequisition.icdCodes || [];
		// Check if the page should be 'locked' (Requisition has been accessioned)
		let disableInputs = this.props.userInfo.adminUser !== 'true' && Boolean(this.props.activeGearRequisition && this.props.activeGearRequisition.accessionNo);
		
		this.state = {
			omsDiagnosisCodes: this.props.omsRequisition ? this.props.omsRequisition.orderableItem.diagnosisCodes : [],
			otherCodes: defaultValue.filter(code => code.otherCode), // a copy of the 'other' codes saved on the gear req
			value: '',
			suggestions: [],
			disableInputs: disableInputs,
			fetchIndex: 0,
			form: {
				diagnosisCodes: {
					value: defaultValue.slice(0) // a copy of the dx codes saved on the gear req
				}
			},
			dirty: false,
		}
		this.changeDxCode = this.changeDxCode.bind(this);
		this.loadSuggestions = this.loadSuggestions.bind(this);
		this.debouncedLoadSuggestions = _.debounce(this.loadSuggestions, 250);
        this.goBack = this.goBack.bind(this);
		this.validate = this.validate.bind(this);
		this.addLineItem = this.addLineItem.bind(this);
        this.onClick = this.onClick.bind(this);
        this.handleAdditionalCodeKeypress = this.handleAdditionalCodeKeypress.bind(this);
    }
	componentDidMount() {
		// Manual ref management because of the limitations of class components
		if (this.props.editRef) {
			this.props.editRef({
				save: this.onSave,
				reset: () => {},
				isDirty: this.isDirty,
			});
		}
		if (this.props.activeGearRequisition.addOnOptions.find(
				addOn => addOn.name.indexOf('SARS') > -1)) {
			let omsCodes = this.state.omsDiagnosisCodes;
			let dxCode1 = {
					 code: "U07.1",
					 name: "COVID-19",
					 otherCode: false	 
				};
			omsCodes.push(dxCode1);
			let dxCode2 = {
					 code: "Z20.828",
					 name: "Contact W And Exposure To Oth Viral Communicable Diseases",
					 otherCode: false	
				};
			omsCodes.push(dxCode2);
			
			this.setState({
				omsDiagnosisCodes: omsCodes
			});
		}
	}
	setDirty = (value) => {
		this.setState({dirty: value});
		this.props.setDirty(value);
	}
	isDirty = () => {
		return this.state.dirty;
	}
    goBack(e){
        if (this.props.doConfirm(e)){
            this.props.updateStep(this.props.gearOrder, 'diagnosis', 'Back', this.props.activeGearRequisitionId);
		} else {
            e.preventDefault();
        }
    }
    changeDxCode(e) {
        if (!this.props.dirty) {
			this.setDirty(true);
		}
		
		let form = Object.assign({}, this.state.form);
		if (e.currentTarget.checked) {
			let selectedCode = this.state.omsDiagnosisCodes.find(code => code.code === e.currentTarget.value);
			// the selected code may be an 'other' code that was previously entered on the req
			if (!selectedCode) {
				selectedCode = this.state.otherCodes.find(code => code.code === e.currentTarget.value);
			}
			form.diagnosisCodes.value.push(selectedCode);
		} else {
			form.diagnosisCodes.value = form.diagnosisCodes.value.filter(code => code.code !== e.currentTarget.value);
		}
		
		this.setState({
			form: this.validate(this.rankDiagnosisCodes(form))
		});
	}
	rankDiagnosisCodes(form) {
		let rank = 1;
		// first rank the 'other' codes in the order they were added
		form.diagnosisCodes.value.forEach(code => {
			if (code.otherCode === true) {
				code.rank = rank++;
			}
		});
		// then rank the selected req codes in the order they show up on the req, not the order they were selected
		this.state.omsDiagnosisCodes.forEach(omsCode => {
			let selectedCode = form.diagnosisCodes.value.find(code => code.code === omsCode.code);
			if (selectedCode) {
				selectedCode.rank = rank++;
			}
		});
		
		return form;
	}
	validate(form) {
		Object.values(form).forEach(prop => {
			prop.valid = true;
			prop.message = "";
		});
		const isHRSAClaim =  this.props.activeGearRequisition.billingMethod ? 
				 this.props.activeGearRequisition.billingMethod.toUpperCase().indexOf('HRSA')>-1 : false;
		if ((this.props.activeGearRequisition.insuranceBillingSelected || this.props.activeGearRequisition.medicareTricareBillingSelected || isHRSAClaim)
				&& (form.diagnosisCodes.value === null || form.diagnosisCodes.value.length === 0)) {
					
			form.diagnosisCodes.valid = false;
			if (this.state.omsDiagnosisCodes && this.state.omsDiagnosisCodes.length) {
				form.diagnosisCodes.message = 'Please select a diagnosis code.';
			} else {
				form.diagnosisCodes.message = 'Please add a diagnosis code.';
			}
		}
		
		return form;
	}

	// This onSave works separately from the onClick for the inlineEdit functions
	onSave = () => {
		const validatedForm = this.validate(this.state.form);
		const isValid = Object.values(validatedForm).every(prop => prop.valid);
		this.setState({
			form: validatedForm
		}, () => {
			if (!isValid) {
				scrollToMessage();
			}
		});

		if (isValid) {
			let reqId = this.props.activeGearRequisitionId;
			let selectedCodes = validatedForm.diagnosisCodes.value
			.filter(code => !code.otherCode)
			.map(code => code.rank + "_" + code.code);
			let selectedOtherCodes = validatedForm.diagnosisCodes.value
			.filter(code => code.otherCode)
			.map(code => code.rank + "_" + code.code);

			this.props.setLoading(true);
			return fetch(process.env.REACT_APP_GEAR_REST_URL + '/diagnosisCodes/', {
				mode: 'cors',
				credentials: 'include',
				method: 'PUT',
				timeout: 1000,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					'selectedCodes': selectedCodes,
					'otherCodes': selectedOtherCodes,
					'gearReqId': reqId
				})
			})
			.then(response => {
				if (response.ok) {
					return response.json();
				} else {
					return Promise.reject('an unexpected error has occurred. please call us at 800-522-4762.');
				}
			})
			.then(json => {
				if (json.id) {
					this.props.setGearOrder(json);
					this.setDirty(false);
					this.props.updateStep(json, 'diagnosis', 'Next', this.props.activeGearRequisitionId);
					return Promise.resolve(json);
				}
			})
			.catch(error => {
				this.props.showError(error.message);
				console.log('Diagnosis code selection request failed', error);
				if (this.props.editRef) {
					return Promise.reject('an unexpected error has occurred. please call us at 800-522-4762.');
				}
			})
			.finally(() => this.props.setLoading(false));
		} else {
			if (this.props.editRef) {
				return Promise.reject('ValidationError');
			}
		}
	}

	onClick(event) {
		event.preventDefault();
		if( this.state.disableInputs ) {
			// No back-end updates required
			this.props.updateStep(this.props.gearOrder, 'diagnosis', 'Next', this.props.activeGearRequisitionId);
			return;
		}
		this.onSave();
	}
	addLineItem() {
		var greqCodes = this.state.omsDiagnosisCodes;
		var otherCodes = document.getElementsByName("otherCodes");

		//validate code before adding to list.
		var newCodeElement = document.getElementsByClassName("react-autosuggest__input");
		var enteredCode = newCodeElement[0].value.toUpperCase().trim();
		if(enteredCode !== "") {
			fetch(process.env.REACT_APP_GDX_WEB_URL+'/api/dxcodes/'+enteredCode, {
				  method: 'GET',
				  mode: 'cors',
				  credentials: 'include',
				  headers: {
				    'Accept': 'application/json'
				  }
				})
				.then(response => {
					//hide any leftover alerts
					document.getElementById('invalidCodeAlert').className = "hidden";
					document.getElementById('duplicateCodeAlert').className = "hidden";

					if (response.ok) {
						//response.json() returns a promise, use .then() to access attributes stored in Promise Value. (ex: obj.description)
						 return response.json();
					} else { // error
						//show invalid code alert
						document.getElementById('invalidCodeAlert').className = "";
					}
			}).then(obj => {
				if(obj.active && obj.version === "10") {
					var definedCodes = [];

					//greqCodes is an array of objects, extract codes into array
					for (var i = 0; i < greqCodes.length; i++ ) {
						definedCodes.push(greqCodes[i].code);
					}
					for(i = 0; i < otherCodes.length; i++ ) {
						definedCodes.push(otherCodes[i].value);
					}

					//entered code is included in set of pre-defined codes from gReq- select list item
					if(definedCodes.indexOf(enteredCode) > -1) {
						var allCodeInputs = document.querySelectorAll("[name='diagnosisCodes'], [name='otherCodes']");
						let codeAlreadySelected = false;
						for (i = 0; i < allCodeInputs.length; i++ ) {
							let code = allCodeInputs[i];
							if(code.value === enteredCode) {
								codeAlreadySelected = code.checked;
								code.checked = true;
							}
						}
						
						if (!codeAlreadySelected) {
							let selectedCode = this.state.omsDiagnosisCodes.find(code => code.code === enteredCode);
							// the selected code may be an 'other' code that was previously entered on the req
							if (!selectedCode) {
								selectedCode = this.state.otherCodes.find(code => code.code === enteredCode);
							}
							let form = Object.assign({}, this.state.form);
							form.diagnosisCodes.value.push(selectedCode);
							this.setState({
								form: this.validate(this.rankDiagnosisCodes(form))
							});
						}
						
						//show duplicate alert
						document.getElementById('duplicateCodeAlert').className = "";
					} else {
						//add new code to list
						let form = Object.assign({}, this.state.form);
						let otherCodes = this.state.otherCodes;
						let code = {
							code: obj.code,
							name: obj.description,
							otherCode: true,
							newCode: true
						};
						otherCodes.push(code);
						form.diagnosisCodes.value.push(code);
						this.setState({
							form: this.validate(this.rankDiagnosisCodes(form)),
							otherCodes: otherCodes,
							value: "",
							suggestions: []
						});
					}
				} else { //code is valid, but is not icd10
					document.getElementById('invalidCodeAlert').className = "";
				}
			})
			.catch(error => { console.log('Diagnosis code selection request failed', error); });
		}
	}
	onChange = (event, { newValue }) => {
	    this.setState({
	      value: newValue
	    });
	};
	onSuggestionsFetchRequested = ({ value }) => {
		 this.debouncedLoadSuggestions(value);
	};
	loadSuggestions(value) {
		// track the index of this fetch, so if when the ajax call returns we can confirm it was the most recent call.
		// the fetch API 'abort' mechanism is not fully supported yet (https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
		let fetchIndex = this.state.fetchIndex + 1;
		this.setState({
			fetchIndex: fetchIndex
		});
		fetch(process.env.REACT_APP_GEAR_REST_URL+'/getDxCodeSuggestions?searchTerm='+value, {
			mode: 'cors',
			credentials: 'include',
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		})
		.then(response => response.json())
		.then(json => {
			// only show the results if this returned fetch was the most recent one
			if (fetchIndex === this.state.fetchIndex) {
				let results = json.results;
				if (json.omittedResults > 0) {
					results.push({
						code: "",
						name: " ... There are " + json.omittedResults + " additional active codes ..."
					});
				}
				this.setState({
					suggestions: results
				});
			}
		})
		.catch(error => 
		{ 
			this.setState({
				showError:true,
				errorMsg: "The network is currently unavailable. Please call us at 800-522-4762."
			});
			this.props.setLoading(false);
			console.log('Diagnosis code search request failed', error); 
		});
	}
	getSuggestionValue(suggestion) {
		return suggestion.code;
	}
	onSuggestionsClearRequested = () => {
	    this.setState({
	      suggestions: []
	    });
	};
	onSuggestionSelected = (event, { method }) => {
		if (method === 'enter') {
			event.preventDefault();
		}
		// Delay before calling addLineItem to give the Autosuggest input time to be updated with the selection
		setTimeout( () => {this.addLineItem()}, 50);
	};
	renderSuggestion(suggestion) {
		var code = suggestion.code;
		if(code!=="") {
			//valid, active code
			return (
				<span style={{paddingLeft:10}}><strong>{suggestion.code}</strong> &nbsp; {suggestion.name}</span>
		    );
		} else {
			//There are xx additional codes... option
			return (
				<span style={{color:'darkgray',paddingLeft:10}}>{suggestion.name}</span>
			);	
		}
	}
	handleAdditionalCodeKeypress(event) {
		if (event.which === 13) {
			event.preventDefault();
			this.addLineItem()
		}
	}
	render() {
		const requisitionResponses = this.props.activeGearRequisition;
		const {value, suggestions} = this.state;
		const inputProps = {
			 placeholder: "Enter Additional Code..",
			 value,
			 onChange: this.onChange,
			 onKeyPress: this.handleAdditionalCodeKeypress
		};
		var greqCodes = [];
		var otherCodes = [];
		var storedCodes = [];

		//populate array of available codes from gReq
		for (var i = 0; i < this.state.omsDiagnosisCodes.length; i++) {
			greqCodes.push(this.state.omsDiagnosisCodes[i].code);
		}

		//populate array of stored codes from GearIcd table
		for (i = 0; i < requisitionResponses.icdCodes.length; i++) {
			storedCodes.push(requisitionResponses.icdCodes[i].code);
		}

		//populate array of 'other' codes
		for (i = 0; i < this.state.otherCodes.length; i++) {
			otherCodes.push(this.state.otherCodes[i]);
		}
		
		// Only show additional code input if the page is unlocked
		let additionalCode;
		if( !this.state.disableInputs ) {
			additionalCode = 
				<div className="row">
					<div style={{display: 'inline-block',marginLeft:'1em'}}>
						<Autosuggest id="newCodeInput" suggestions={suggestions}
										 onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
										 onSuggestionsClearRequested={this.onSuggestionsClearRequested}
										 onSuggestionSelected={this.onSuggestionSelected}
										 highlightFirstSuggestion={true}
										 getSuggestionValue={this.getSuggestionValue}
										 renderSuggestion={this.renderSuggestion}
										 inputProps={inputProps}
										 maxSearchResults={20}
										 onFocus={()=>this.setDirty(true)} />
					</div>
					<button type="button" className="btn btn-primary radius btn-sm" style={{minWidth:'85px',margin:'0 0 0 1em'}}
							  onClick={()=>this.addLineItem()} disabled={this.state.disableInputs || !this.state.value}> Add Code </button>
				</div>;
		}

		// Hide definition of medical necessity unless the billing method is Medicare
		const isMedicare = requisitionResponses.billingMethod ? 
	      requisitionResponses.billingMethod.toUpperCase().indexOf('MEDICARE')>-1 : false;
		return (
				<div className="col-md-12">
					{!this.props.editRef && <h2>Diagnosis Codes<br />
						<small>{this.props.getRequisitionTitle(this.props.omsRequisition)}</small>
					</h2>}
					{this.state.disableInputs && (
						<AccessionedOrderAlert />
					)}
					{isMedicare && 
						<MedicalNecessityDisclaimer />
					}
					<div className="col-md-12" >
						<div className="alert alert-warning" hidden={!this.state.showError} role="alert">
							{this.state.errorMsg}
						</div>
						<div id="invalidCodeAlert" className="hidden">
							<div className="alert alert-danger" role="alert">
								<strong>Please enter a valid ICD code.</strong>
							</div>
						</div>
						<div id="duplicateCodeAlert" className="hidden">
							<div className="alert alert-info alert-dismissible" role="alert">
								<button type="button" className="close" data-dismiss="alert" aria-label="Close">
									<span aria-hidden="true">×</span></button> <strong>The code you've entered is defined on the requisition.
								It has been selected in the list for you.</strong>
							</div>
						</div>
					</div>
					<div className="col-md-8" id="dxCodes">
						<div className="well">
							{this.state.form.diagnosisCodes.valid === false &&
								<span className="validation-message text-danger">{this.state.form.diagnosisCodes.message}</span>
							}
							<form id="diagnosis-codes-form" noValidate>
								<ul className="list list-unstyled" id="diagnosisCodeList">
									{otherCodes.map(function(listValue) {
										return  <li className={"checkbox " + (this.state.form.diagnosisCodes.valid === false ? "has-error" : "")} key={listValue.code}>
											<label>
												<input type="checkbox" value={listValue.code}
															 name="otherCodes" onChange={this.changeDxCode} defaultChecked="true"
															 disabled={this.state.disableInputs}/>
												{listValue.code} &nbsp; <em>{listValue.name} {listValue.newCode && <span style={{"color":"red"}}> NEW! </span>}</em>
											</label>
										</li>
									},this)}
									{this.state.omsDiagnosisCodes.map(function(listValue, i) {
										return  <li className={"checkbox " + (this.state.form.diagnosisCodes.valid === false ? "has-error" : "")} key={listValue.name}>
													<label>
														<input type="checkbox" value={listValue.code}
															name="diagnosisCodes" onChange={this.changeDxCode}
															defaultChecked={storedCodes.indexOf(listValue.code) > -1}
															disabled={this.state.disableInputs}/>
														{listValue.code} &nbsp; <em>{listValue.name}</em>
													</label>
												</li>
									},this)}
								</ul>
								{additionalCode}
							</form>
						</div>
					</div>
					<div className="space-top"></div>
					<div className="space-top"></div>
					{!this.props.editRef && <div className="row">
						<div className="col-md-12 sticky-bottom">
							<button type="button" className="btn btn-white radius btn-sm margin-clear" onClick={this.goBack}>
								<i className="pl-10 fa fa-arrow-circle-left"></i> &nbsp;
								Back
							</button>
							<button type="submit" form="diagnosis-codes-form" className="btn btn-primary radius btn-sm margin-clear pull-right" onClick={this.onClick}>
								Next
								<i className="pl-10 fa fa-arrow-circle-right"></i>
							</button>
						</div>
					</div>}
					<div className="col-md-12">
						<p>
							Diagnosis codes must be provided by the referring practitioner and must relate specifically
							to the patient’s condition. Some codes may not be applicable to the patient and
							should not be selected.
						</p>
					</div>
					<div className="col-md-12">
						<p>
							Due to the possibility of regulatory and/or methodology changes, CPT and ICD-10 codes are
							subject to change without prior notification.
						</p>
					</div>
				</div>
		)
	}
}

// wrap the component in the workflow and requisition step HOCs to get access to common logic
export default withWorkflow(withRequisitionStep(DiagnosisCodes));
